/* ************************* */
//
// Dreamcoat Auth - Shared Utilities
// Common functions used across dreamcoat auth forms
//
/* ************************* */

/**
 * Initialize and clear localforage
 */
function initLocalForage() {
    if (typeof localforage !== "undefined" && localforage) {
        localforage.config({
            driver: localforage.LOCALSTORAGE,
            name: "sw_local",
        });
        localforage.clear();
    }
}

/**
 * Toggle password visibility for an input field
 * @param {jQuery} inputEl - The password input element
 * @param {jQuery} toggleBtn - The toggle button element
 */
function togglePasswordVisibility(inputEl, toggleBtn) {
    const type = inputEl.attr("type");
    if (type === "password") {
        inputEl.attr("type", "text");
        toggleBtn
            .find(".fa-regular")
            .removeClass("fa-eye")
            .addClass("fa-eye-slash");
    } else {
        inputEl.attr("type", "password");
        toggleBtn
            .find(".fa-regular")
            .removeClass("fa-eye-slash")
            .addClass("fa-eye");
    }
}

/**
 * Validate email format
 * @param {string} email - The email to validate
 * @returns {boolean} - True if valid email format
 */
function isValidEmail(email) {
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    return emailRegex.test(email);
}

/**
 * Update button state with spinner
 * @param {jQuery} buttonEl - The button element
 * @param {jQuery} labelEl - The label span element inside button
 * @param {string} state - 'working', 'success', or 'ready'
 * @param {Function} validateFn - Optional validation function to call on 'ready' state
 */
function updateButtonState(buttonEl, labelEl, state, validateFn) {
    switch (state) {
        case "working":
        case "verifying":
            buttonEl.prop("disabled", true);
            labelEl.addClass("with-spinner");
            break;
        case "success":
            buttonEl.prop("disabled", true);
            labelEl.removeClass("with-spinner");
            break;
        default:
        case "ready":
            if (typeof validateFn === "function") {
                validateFn();
            }
            labelEl.removeClass("with-spinner");
            break;
    }
}

/**
 * Show a dynamic alert - creates and appends the alert
 * @param {string|jQuery} target - Container ID (for box mode) or input element/selector (for inline mode)
 * @param {string} type - 'error' or 'success'
 * @param {string} message - The message to display
 * @param {string} displayMode - 'box' (prepend to container) or 'inline' (append after input's parent)
 */
function showAlertBox(target, type, message, displayMode = "box") {
    // Remove any existing alert first
    hideAlertBox();

    if (displayMode === "inline") {
        // Inline error - append after input's parent
        // Support both jQuery element and selector string
        const inputEl = target instanceof $ ? target : $(target);
        inputEl.parent().after(
            $("<div>", {
                id: "dynamic-alert",
                class: "error-message visible",
            }).text(message)
        );
    } else {
        // Box alert - prepend to container
        const iconHtml =
            type === "error"
                ? '<i class="fa-solid fa-circle-exclamation"></i>'
                : type === "info"
                ? '<i class="fa-solid fa-circle-info"></i>'
                : '<i class="fa-solid fa-circle-check"></i>';

        const alertHtml = `
            <div id="dynamic-alert" class="alert-box alert-${type} visible">
                <span class="alert-icon">${iconHtml}</span>
                <span class="alert-text">${message}</span>
            </div>
        `;

        // Append to container
        $("#" + target).prepend(alertHtml);
    }
}

function hideAlertBox() {
    $("#dynamic-alert").remove();
}
/**
 * Fire-and-forget reCAPTCHA v3 execute for context (no token sent to our backend).
 * Improves scoring signal per https://developers.google.com/recaptcha/docs/v3
 */
function recaptchaV3Ping(action) {
    const siteKey = window?.GOOGLE_RECAPTCHA_V3_API_SITE_KEY;
    if (typeof grecaptcha === "undefined" || !siteKey) return;
    grecaptcha.ready(function () {
        grecaptcha.execute(siteKey, { action: action }).catch(function () {});
    });
}

module.exports = {
    initLocalForage,
    togglePasswordVisibility,
    isValidEmail,
    updateButtonState,
    showAlertBox,
    hideAlertBox,
    recaptchaV3Ping,
};
